import { HttpClient } from '@angular/common/http';
import { Injectable, Injector } from '@angular/core';
import { BaseService, EnvironmentService, GridInfo, ResponseResult } from 'tnx-shared';

@Injectable({
    providedIn: 'root',
})
export class RuleService extends BaseService {
    entityName = 'Rule';
    serviceCode = 'RuleTracking';

    constructor(http: HttpClient, injector: Injector,
                private _environmentService: EnvironmentService) {
        super(http, injector, ``);
        this.endPoint = _environmentService.getHttpServiceEndpointWithVersion(this.serviceCode);
        this.serviceUri = `${this.endPoint}/${this.entityName}`;
    }

    getDetailCustom(id: string, pid: string) {
        const url = `${this.serviceUri}/GetDetailCustom/${id}&pid=${pid}`;
        return this.defaultGet(url);
    }

    manualCheck(gridInfo: GridInfo): Promise<ResponseResult> {
        const apiUri = `${this.serviceUri}/ManualCheck`;
        return this.defaultPost(apiUri, gridInfo);
    }

    commit(rules: any): Promise<ResponseResult> {
        const apiUri = `${this.serviceUri}/Commit`;
        return this.defaultPost(apiUri, rules);
    }

    getClientRule(gridInfo: GridInfo): Promise<ResponseResult> {
        const apiUri = `${this.serviceUri}/getClientRule`;
        return this.defaultPost(apiUri, gridInfo);
    }

    updateClientCheck(rule: any): Promise<ResponseResult> {
        const apiUri = `${this.serviceUri}/UpdateClientCheck`;
        return this._http.put<ResponseResult>(apiUri, rule).toPromise();
    }
}
